import styled from 'styled-components';
import {device} from '../../styled/device';
import Select from '../../components/acommon/FieldSelect';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  max-width: 288px;
`;

export const ReservationGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 25px 30px;
  margin-bottom: 25px;

  @media (max-width: ${device.tablet}) {
    grid-template-columns: auto;
    justify-content: center;
  }

  & ${Item}:nth-child(2) {
    @media (max-width: ${device.tablet}) {
      display: none;
    }
  }
`;

export const SelectStyled = styled(Select)`
  margin: 0;
`;

export const Form = styled.form`
  display: grid;
  margin-top: 20px;
`;

export const Logo = styled.img`
  justify-self: center;
  width: 220px;
  margin-bottom: 70px;
`;
